import { defineMessages, MessageDescriptor } from 'react-intl';

import { Inconsistency } from '../types/inconsistency.js';

export const INCONSISTENCIES_MESSAGES: Record<
  Inconsistency,
  MessageDescriptor
> = defineMessages({
  misalignedDatapoints: {
    id: 'ks0AoNP1Ns6On08M',
    defaultMessage: 'Misaligned datapoints detected',
    description:
      'Message emitted from the charts when misaligned data points across series are detected',
  },
  undefinedDatapointValues: {
    id: 'jBONVMflkBhpYk65',
    defaultMessage: 'Datapoints with undefined value detected',
    description:
      'Message emitted from the charts when data points with undefined value are detected',
  },
});
